<template>
  <div class="home">
    <!-- <router-link to="/liveBanner">Live Banner</router-link>|
    <router-link to="/liveFreeEticket">Complimentary E-Ticket</router-link>-->
      <div class="row">
        <div class="col-12">
          <a-table
            :scroll="$aTableScroll"
            :columns="columns"
            :data-source="uatItems"
            :pagination="this.pagination"
            v-show="this.env != 'production'"
            rowKey="url"
          >
            <template slot="title">
              <strong>UAT information</strong>
            </template>
            <a slot="url" slot-scope="text,record">
              <a :href="record.url" target="_blank">{{ record.url}}</a>
            </a>
            <a slot="remark" slot-scope="text,record">
              <b-card-text>{{ record.remark }}</b-card-text>
            </a>
          </a-table>
          <a-table
            :scroll="$aTableScroll"
            :columns="columns"
            :data-source="prodItems"
            :pagination="this.pagination"
            v-show="this.env === 'production'"
             rowKey="url"
          >
            <template slot="title">
              <strong>PROD information</strong>
            </template>
            <a slot="url" slot-scope="text,record">
              <a :href="record.url" target="_blank">{{ record.url}}</a>
            </a>
            <a slot="remark" slot-scope="text,record">
              <b-card-text>{{ record.remark }}</b-card-text>
            </a>
          </a-table>
        </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src

const columns = [
  {
    title: "URL",
    dataIndex: "url",
    key: "url",
    width: "70%",
    scopedSlots: { customRender: "url" },
  },
  {
    title: "Remark",
    dataIndex: "remark",
    key: "remark",
    width: "30%",
    scopedSlots: { customRender: "remark" },
  },
];

export default {
  name: "Home",
    data() {
    return {
      env: process.env.NODE_ENV,
      uatItems: [ {"url": "https://liveuat.cityline.com", "remark": "WEB" },
             {"url": "https://s3.console.aws.amazon.com/s3/buckets/cdt-web-uat?region=ap-east-1&tab=objects", "remark": "WEB bucket" },
             {"url": "https://console.aws.amazon.com/cloudfront/home?region=ap-east-1#distribution-settings:E1EKTGAU1LKIOQ", "remark": "WEB cloudfront" },
             {"url": "https://liveadminuat.cityline.com", "remark": "CMS (account: superadmin/p@ssw0rd#live!)" },
             {"url": "https://s3.console.aws.amazon.com/s3/buckets/cdt-admin-web-uat?region=ap-east-1&tab=objects", "remark": "CMS bucket" },
             {"url": "https://console.aws.amazon.com/cloudfront/home?region=ap-east-1#distribution-settings:E2EQZY1QK49MQD", "remark": "CMS cloudfront" },
            ],
      prodItems: [ {"url": "https://live.cityline.com", "remark": "WEB" },
             {"url": "https://s3.console.aws.amazon.com/s3/buckets/cdt-web-production?region=ap-east-1&tab=objects", "remark": "WEB bucket" },
             {"url": "https://console.aws.amazon.com/cloudfront/home?region=ap-east-1#distribution-settings:E3ILU79J7PI8OB", "remark": "WEB cloudfront" },
             {"url": "https://liveadmin.cityline.com", "remark": "CMS" },
             {"url": "https://s3.console.aws.amazon.com/s3/buckets/cdt-admin-web-production?region=ap-east-1&tab=objects", "remark": "CMS bucket" },
             {"url": "https://console.aws.amazon.com/cloudfront/home?region=ap-east-1#distribution-settings:E1XNX0JIPQCSG", "remark": "CMS cloudfront" },
            ],
      columns,
      pagination: { defaultPageSize: 10 },
    };
  },
};
</script>
